export default {
    login: '/login',
    getShopMember: '/getShopMember',//获取门店员工信息
    allShop: '/allShop',//获取门店信息
    allPosition: '/allPosition',//获取岗位信息
    allPeople: '/allPeople',//获取工厂所有员工信息
    getShopColor: '/getShopColor',//获取颜色
    allDriver: '/allDriver',//获取驾驶员数据接口

    findOut: '/findOut',//出厂查询
    getOutByNo: '/getOutByNo',//根据出厂单号查询衣物信息
    queryOrder: '/queryOrder',//订单号或条形码查询
    orderAbout: 'orderAbout',//点击衣物信息查询工厂和门店操作记录
    warn: '/warn',//衣物预警
    workCount: '/workCount',//业绩查询
    findLossBid: '/findLossBid',//掉标衣物查看
    matchBid: '/matchBid',//掉标衣物匹配
    operate: '/operate',//员工的岗位操作权限
    changeClothProcess: '/changeClothProcess',//衣物工序（出厂单独接口）
    outFactory: '/outFactory',//衣物出厂
    countPosition: '/countPosition',//今日工作件数
    outSys: '/outSys',//确认出厂
    returnWhy: '/returnWhy', // 返工原因
    insertReturn: '/insertReturn', // 添加返工
    addExtra: '/addExtra',
    returnList: '/returnList',  // 返工记录列表接口
    extraList: '/extraList',     // 补款列表
    sureAccept: '/sureAccept',   // 接收返工
    shopMoney: '/shopMoney',      // 单个门店营业额查询
    shopTypeMoney: '/shopTypeMoney', // 门店类型营业额统计
    shopClothCount: '/shopClothCount',  // 门店每日收衣统计
    checkClothCount: '/checkClothCount'  // 工厂总检数据查询
}